import $ from "jquery";
import select2 from "select2";

// Ensure Select2 is registered on this jQuery instance
if (!$.fn.select2) {
  select2(window, $);
}

// Load Portuguese (Brazil) translations if available
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require("select2/dist/js/i18n/pt-BR");
} catch (e) {
  // ignore
}

export const DEFAULT_OPTIONS = { theme: "bootstrap-5", language: "pt-BR" };

export function initSelector(selector, options = {}) {
  const opts = Object.assign({}, DEFAULT_OPTIONS, options);
  $(selector).each((_, el) => {
    const $el = $(el);
    if (!$el.data("select2")) {
      try {
        $el.select2(opts);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("select2 init error:", e);
      }
    }
  });
}

export function destroySelector(selector) {
  $(selector).each((_, el) => {
    const $el = $(el);
    if ($el.data("select2")) {
      try {
        $el.select2("destroy");
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("select2 destroy warning:", e);
      }
    }
  });
}

export function buildAjaxOptions(url, resultMapper, perPage = 20) {
  return {
    url,
    dataType: "json",
    delay: 250,
    cache: true,
    data: function (params) {
      return { q: params.term, page: params.page };
    },
    processResults: function (data, params) {
      params = params || {};
      let results = [];
      try {
        results = $.map(data, resultMapper);
      } catch (e) {
        results = [];
      }
      return {
        results,
        pagination: { more: data && data.length && data.length === perPage },
      };
    },
  };
}

export function bindLifecycle(initFn, selector) {
  document.addEventListener("turbo:load", initFn);
  document.addEventListener("DOMContentLoaded", initFn);
  // Re-init on Turbo Frame loads (dynamic frame content)
  document.addEventListener("turbo:frame-load", initFn);

  // jQuery-driven insertions: AJAX completions, cocoon nested inserts, and Bootstrap modals
  try {
    if (typeof $ !== "undefined" && $.fn) {
      $(document).on("ajaxComplete", () => initFn());
      $(document).on("cocoon:after-insert", () => initFn());
      $(document).on("shown.bs.modal", () => initFn());
    }
  } catch (e) {
    // ignore if jQuery isn't available
  }

  document.addEventListener("turbo:before-cache", () =>
    destroySelector(selector)
  );
}
